import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

export const MenuWrapper = styled.div`
    align-items: center;
    display: flex;
`;

export const MenuActions = styled.div`
    align-items: center;
    display: flex;
    gap: 24px;
`;

export const Divider = styled.div`
    ${({ theme: { palette } }) => css`
        background-color: ${palette.neutral.dividers};
        height: 19px;
        width: 1px;
    `}
`;

export const IconWrapper = styled.div`
    position: relative;
`;

export const IconButton = styled.button<{ isOpen?: boolean }>(
    ({ isOpen }) => css`
        background-color: transparent;
        border: none;
        cursor: pointer;
        padding: 0;
        position: relative;
        ${isOpen && 'pointer-events: none;'}
    `,
);

export const MenuIcon = styled(IconManager)`
    pointer-events: none;
`;

export const NotificationsDot = styled.div`
    ${({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.default};
        border-radius: ${radius[50]}%;
        border: 1px solid ${palette.neutral.white};
        height: 10px;
        pointer-events: none;
        position: absolute;
        right: 2px;
        top: 3px;
        width: 10px;
    `}
`;

export const GuestMode = styled.div(
    ({ theme: { palette, radius } }) => css`
        background-color: ${palette.neutral.gray};
        border-radius: ${radius[8]}px;
        padding: 2px 18px;
    `,
);

export const GuestModeText = styled(Typography.TextBody_12_18)(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight.bold};
        text-transform: uppercase;
    `,
);
